import { ListViewSettings } from '../../interfaces/list-view-models';

export function applyListViewDefaults(source: ListViewSettings): ListViewSettings {
  return {
    ...source,
    allowCreate: source.allowCreate ?? true,
    allowEdit: source.allowEdit ?? true,
    allowGalleryMode: source.allowGalleryMode ?? true,
    allowTableMode: source.allowTableMode ?? true,
    searchPlaceholder: source.searchPlaceholder ?? 'Enter search text',
  };
}
